export default __webpack_public_path__ + "static/media/twitter.d26d1b4e.svg";